import MentionExtension from "@tiptap/extension-mention";
import { ReactNodeViewRenderer } from "@tiptap/react";

import Variable from "./Variable";

export default MentionExtension.extend({
  name: "variable",

  addNodeView() {
    return ReactNodeViewRenderer(Variable);
  },

  addAttributes() {
    return {
      id: {
        isRequired: true,
        default: false,
        parseHTML: (element) => element.getAttribute("data-id"),
        renderHTML: (attrs) => ({
          "data-id": attrs.id,
        }),
      },
      label: {
        isRequired: true,
        default: false,
        parseHTML: (element) => element.getAttribute("data-label"),
        renderHTML: (attrs) => ({
          "data-label": attrs.label,
        }),
      },
      fallback: {
        isRequired: true,
        default: "",
        parseHTML: (element) => element.getAttribute("data-fallback"),
        renderHTML: (attrs) => ({
          "data-fallback": attrs.fallback,
        }),
      },
      isCustomVar: {
        isRequired: true,
        default: false,
        parseHTML: (element) => {
          const attr = element.getAttribute("data-is-custom-var");

          // Handle string representation of boolean value
          return attr === "true";
        },
        renderHTML: (attrs) => ({
          "data-is-custom-var": attrs.isCustomVar,
        }),
      },
    };
  },
});
